import { DiagnosticFunnel } from '../../../components/tools/DiagnosticFunnel';
import { AudienceToolHero } from '../../../components/blocks/AudienceToolHero';
import { getAudienceToolContent } from '../../../config/audience-tool-content';
import { BreadcrumbListLd } from '../../../components/seo/jsonld/BreadcrumbList';

const content = getAudienceToolContent('professionnels', 'diagnostic-cee')!;

export default function ProfessionnelsDiagnosticCeePage() {
  return (
    <>
      <AudienceToolHero
        content={content}
        backHref="/professionnels"
        backLabel="Espace professionnels"
        duration="60 sec"
      >
        <DiagnosticFunnel lockedAudience="professionnels" />
      </AudienceToolHero>

      <BreadcrumbListLd
        items={[
          { name: 'Accueil', url: 'https://solutionecofrance.fr/' },
          { name: 'Espace professionnels', url: 'https://solutionecofrance.fr/professionnels' },
          { name: 'Diagnostic CEE', url: 'https://solutionecofrance.fr/professionnels/diagnostic-cee' },
        ]}
      />
    </>
  );
}
